import React, { useState } from "react";

import {
	HelpMenuContainer,
	HelpMenuImage,
	HelpMenuLabel,
	HelpMenuText,
	HelpMenuLabelImage,
	HelpMenuOverlay,
	HelpImageArrow,
	HelpCloseCircle,
} from "./style";

import "./style.css";

import type { MenuProps } from "antd";
import { Dropdown, Space } from "antd";
import {
	closeCircleImage,
	guidesImage,
	helpArrowImage,
	mailImage,
	phoneImage,
	webChatImage,
	whatsAppImage,
} from "../../../utils/staticImages";

const HelpMenu = () => {
	const [showOverlay, setShowOverlay] = useState(false);

	const hideOverlay = (e: React.MouseEvent) => {
		e.stopPropagation();

		setShowOverlay(false);
	};

	const items: MenuProps["items"] = [
		{
			label: (
				<HelpMenuLabel>
					<HelpMenuLabelImage $backgroundImage={guidesImage} />
					Kılavuzlar
					<HelpImageArrow $background={helpArrowImage} />
				</HelpMenuLabel>
			),
			key: "0",
		},
		{
			label: (
				<HelpMenuLabel>
					<HelpMenuLabelImage $backgroundImage={phoneImage} />
					0850 399 22 33
				</HelpMenuLabel>
			),
			key: "1",
		},
		{
			label: (
				<a
					href="https://api.whatsapp.com/send?phone=908503992233"
					target="_blank"
					rel="noreferrer"
					onClick={hideOverlay}
				>
					<HelpMenuLabel>
						<HelpMenuLabelImage $backgroundImage={whatsAppImage} />
						WhatsApp
						<HelpImageArrow $background={helpArrowImage} />
					</HelpMenuLabel>
				</a>
			),
			key: "2",
		},
		{
			label: (
				<HelpMenuLabel>
					<HelpMenuLabelImage $backgroundImage={mailImage} />
					destek@koc.enonay.com
					<HelpImageArrow $background={helpArrowImage} />
				</HelpMenuLabel>
			),
			key: "3",
		},
		{
			label: (
				<HelpMenuLabel>
					<HelpMenuLabelImage $backgroundImage={webChatImage} />
					WebChat
					<HelpImageArrow $background={helpArrowImage} />
				</HelpMenuLabel>
			),
			key: "4",
		},
		{
			label: (
				<HelpCloseCircle
					onClick={hideOverlay}
					$background={closeCircleImage}
				/>
			),
			key: "5",
		},
	];

	return (
		<HelpMenuContainer>
			{showOverlay && (
				<HelpMenuOverlay id="help-menu-overlay" onClick={hideOverlay} />
			)}
			<Dropdown
				menu={{ items }}
				trigger={["click"]}
				placement="top"
				overlayClassName="help-menu"
				onOpenChange={() => {
					setShowOverlay(true);
				}}
				open={showOverlay}
			>
				<Space>
					<HelpMenuImage />
					<HelpMenuText>Yardım</HelpMenuText>
				</Space>
			</Dropdown>
		</HelpMenuContainer>
	);
};

export default HelpMenu;
